import type { AgentCanvasAnnotationMetadata, AgentCanvasPoint } from './types';

const componentNodeFromElement = (
  element: Element,
  surface: HTMLElement,
): HTMLElement | null => {
  const node = element.closest<HTMLElement>('.a-node[data-id]');
  if (!node || !surface.contains(node)) return null;
  return node;
};

export const findAgentCanvasAnnotationMetadataAtPoint = (
  surface: HTMLElement,
  point: AgentCanvasPoint,
): AgentCanvasAnnotationMetadata | undefined => {
  const rect = surface.getBoundingClientRect();
  const clientX = rect.left + point.x;
  const clientY = rect.top + point.y;
  const elementsFromPoint = surface.ownerDocument?.elementsFromPoint?.bind(surface.ownerDocument);
  if (!elementsFromPoint || !Number.isFinite(clientX) || !Number.isFinite(clientY)) {
    return undefined;
  }

  for (const element of elementsFromPoint(clientX, clientY)) {
    const node = componentNodeFromElement(element, surface);
    if (!node) continue;

    const cuid = Number(node.dataset.id);
    if (!Number.isInteger(cuid)) continue;

    const kind = node.dataset.component;
    return kind ? { cuid, kind } : { cuid };
  }

  return undefined;
};
